import {
  DeesElement,
  html,
  property,
  customElement,
  css,
  cssManager,
  unsafeCSS,
} from '@designestate/dees-element';

declare global {
  interface HTMLElementTagNameMap {
    'lele-materialicon': LeleMaterialicon;
  }
}

@customElement('lele-materialicon')
export class LeleMaterialicon extends DeesElement {
  public static demo = () => html`<lele-materialicon iconName="visibility"></lele-materialicon>`;

  @property()
  public iconName: string;

  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        line-height: inherit;
        font-size: inherit;
      }
      .material-icons {
        font-family: 'Material Icons';
        font-weight: normal;
        font-style: normal;
        line-height: inherit;
        font-size: inherit;
        display: inline-block;
        line-height: inherit;
        text-transform: none;
        letter-spacing: normal;
        word-wrap: normal;
        white-space: nowrap;
        direction: ltr;

        /* Support for all WebKit browsers. */
        -webkit-font-smoothing: antialiased;
        /* Support for Safari and Chrome. */
        text-rendering: optimizeLegibility;

        /* Support for Firefox. */
        -moz-osx-font-smoothing: grayscale;

        /* Support for IE. */
        font-feature-settings: 'liga';
      }
    `,
  ];

  public render() {
    return html`
      <style></style>
      <i class="material-icons">${this.iconName}</i>
    `;
  }
}
